"use client";

import { Restaurant } from "@/types/inde_menu";
import apiClient from "./apiClient";

export interface RestaurantFilters {
    cuisineType: string[];
    priceRange: string[];
    features: string[];
    rating: number | null;
    openNow: boolean;
    acceptsReservations: boolean;
    deliveryAvailable: boolean;
    takeawayAvailable: boolean;
}

export interface SearchParams extends Partial<RestaurantFilters> {
    query?: string;
    page?: number;
    limit?: number;
    sort?: string;
    lat?: number;
    lng?: number;
    radius?: number;
}

export const apiService = {
    // Restaurants
    getRestaurants: async (params?: SearchParams) => {
        const response = await apiClient.get<any>('/restaurants', { params });
        return response.data;
    },

    getRestaurant: async (id: string) => {
        const response = await apiClient.get<any>(`/restaurants/${id}`);
        return response.data;
    },

    getFeaturedRestaurants: async () => {
        const response = await apiClient.get<any>('/restaurants/featured');
        return response.data;
    },

    getNearbyRestaurants: async (lat: number, lng: number, radius: number) => {
        const response = await apiClient.get<any>('/restaurants/nearby', {
            params: { lat, lng, radius }
        });
        return response.data;
    },

    searchRestaurants: async (query: string, filters?: any) => {
        const response = await apiClient.get<any>('/restaurants/search', {
            params: { query, ...filters }
        });
        return response.data;
    },

    createRestaurant: async (data: any) => {
        const response = await apiClient.post<any>('/restaurants', data);
        return response.data;
    },

    updateRestaurant: async (id: string, data: any) => {
        const response = await apiClient.patch<any>(`/restaurants/${id}`, data);
        return response.data;
    },

    deleteRestaurant: async (id: string) => {
        await apiClient.delete<any>(`/restaurants/${id}`);
    },

    updateRestaurantStatus: async (id: string, status: string) => {
        const response = await apiClient.patch<any>(`/restaurants/${id}/status`, { status });
        return response.data;
    },

    assignStaffToRestaurant: async (restaurantId: string, staffId: string, role: string) => {
        const response = await apiClient.post<any>(`/restaurants/${restaurantId}/staff`, { staffId, role });
        return response.data;
    },

    removeStaffFromRestaurant: async (restaurantId: string, staffId: string) => {
        const response = await apiClient.delete<any>(`/restaurants/${restaurantId}/staff/${staffId}`);
        return response.data;
    },

    getRestaurantSections: async (restaurantId: string) => {
        const response = await apiClient.get<any>(`/restaurants/${restaurantId}/sections`);
        return response.data;
    },
};
